module.exports = __webpack_public_path__ + "static/media/protean_logo.877cc638.svg";